var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCradlepoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "All_Logos",
    "data-name": "All Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.51,143.99h-1.51v-14.65h5.69c3.4,0,4.72,1.88,4.72,4.23s-1.36,4.25-4.72,4.25h-4.19v6.17ZM65.76,136.37c2.1,0,3.09-1.05,3.09-2.81s-.99-2.79-3.09-2.79h-4.25v5.59h4.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.92,143.99l6.02-14.65h1.63l6.05,14.65h-1.67l-1.38-3.42h-7.63l-1.4,3.42h-1.61ZM76.73,131.18l-3.26,7.98h6.54l-3.24-7.98h-.04Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.03,143.99l-3.45-6.38h-4.29v6.38h-1.51v-14.65h6.02c3.32,0,4.7,1.84,4.7,4.13,0,1.96-1.01,3.57-3.36,4l3.69,6.52h-1.82ZM91.87,130.78h-4.58v5.38h4.58c2.08,0,3.07-1.03,3.07-2.7s-.99-2.68-3.07-2.68Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,130.78h-4.68v13.2h-1.51v-13.2h-4.68v-1.44h10.87v1.44Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49,144.3c-4.5,0-7.47-3.38-7.47-7.63s2.97-7.63,7.47-7.63,7.47,3.38,7.47,7.63-2.97,7.63-7.47,7.63ZM122.49,142.87c3.38,0,5.9-2.52,5.9-6.21s-2.52-6.21-5.9-6.21-5.9,2.52-5.9,6.21,2.52,6.21,5.9,6.21Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.11,143.99v-14.65h9.33v1.42h-7.82v5.08h7.39v1.42h-7.39v6.73h-1.51Z",
    fill: "#000",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "154.51 126.28 167.87 126.28 167.87 129.91 159.23 129.91 159.23 133.07 167.51 133.07 167.51 136.84 159.23 136.84 159.23 140.1 168.01 140.1 168.01 143.75 154.51 143.75 154.51 126.28",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.63,
    y: 126.28,
    width: 4.75,
    height: 17.48,
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.72,126.84l-.32,3.74c-3.84-2.22-9.72-1.51-9.83,4.31-.11,5.82,6.06,6.67,9.97,4.7l.25,3.82c-6.91,2.15-15.15-.04-15.12-8.51.03-8.3,8.35-10.6,15.05-8.05",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.71,126.57l-.32,3.64c-2.39-1.32-6.94-1.35-6.94.72,0,3.07,8.11.85,8.11,7.42s-7.72,6.53-12.72,5.03l.36-3.85c3.13,1.46,7.58,1.78,7.58-.75,0-2.79-8.14-1.22-8.14-7.46,0-5.12,6.34-6.49,12.09-4.75",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.05,126.57l-.31,3.64c-2.4-1.32-6.94-1.35-6.94.72,0,3.07,8.11.85,8.11,7.42s-7.72,6.53-12.72,5.03l.36-3.85c3.13,1.46,7.57,1.78,7.57-.75,0-2.79-8.14-1.22-8.14-7.46,0-5.12,6.34-6.49,12.08-4.75",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.94 126.28 266.96 126.28 272.71 137.56 272.71 126.28 277.08 126.28 277.08 143.76 271.4 143.76 265.34 132.27 265.34 143.76 260.94 143.76 260.94 126.28",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98,125.86c4.94,0,8.7,2.89,8.7,9.2s-3.79,9.13-8.7,9.13c-4.91,0-8.67-3.03-8.67-9.13s3.74-9.2,8.67-9.2M246.17,135.06c0,2.67,1.14,5.68,3.81,5.68,2.66,0,3.78-3.01,3.8-5.68.02-2.41-1.14-5.67-3.8-5.67-2.66,0-3.81,3.01-3.81,5.67",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.87,133.65h2.61c1.17.02,2.23-.68,2.22-1.97,0-1.14-.94-1.95-2.15-1.94h-2.68v3.91ZM171.32,126.28h8.57c2.33,0,5.56,1.02,5.56,4.65,0,2.32-1.05,3.63-3.05,4.23.09,0,1.14.45,1.58,1.76.02.04,2.45,6.82,2.48,6.84h-5.05l-1.8-5.25c-.28-.81-.88-1.34-1.73-1.34-.74,0-1.9-.05-1.9,0v6.59h-4.65v-17.48Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M298.65,128.85c-1.74.64-3.66-.26-4.3-1.99-.64-1.74.26-3.66,1.99-4.3l18.53-6.79c1.74-.64,3.66.26,4.3,1.99.64,1.74-.26,3.66-1.99,4.3l-18.53,6.79Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.65,138.88c-1.74.64-3.66-.26-4.3-1.99-.64-1.74.26-3.66,1.99-4.3l18.53-6.79c1.74-.64,3.66.25,4.3,1.99.64,1.74-.26,3.66-1.99,4.3l-18.53,6.79Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.65,148.91c-1.74.64-3.66-.26-4.3-1.99-.64-1.74.26-3.66,1.99-4.3l18.53-6.79c1.74-.64,3.66.25,4.3,1.99.64,1.74-.26,3.66-1.99,4.3l-18.53,6.79Z",
    fill: "#000",
    strokeWidth: 0
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.88,40.93l-26.02-19.83c-1.34-1.02-3.2-1.02-4.54,0h0c-1.96,1.5-1.96,4.45,0,5.95l26.02,19.83c.65.5,1.45.77,2.27.77,3.58,0,5.12-4.55,2.27-6.72Z",
    fill: "#ffad00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.6,40.93l-13.34-10.21c-1.34-1.02-3.2-1.02-4.54,0h0c-1.96,1.5-1.96,4.45,0,5.95l13.34,10.21c.65.5,1.45.77,2.27.77,3.58,0,5.12-4.55,2.27-6.72Z",
    fill: "#ffad00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.99,40.93l-1.56-1.2c-1.34-1.02-3.2-1.02-4.54,0-1.96,1.5-1.96,4.45,0,5.95l1.56,1.2c.65.5,1.45.77,2.27.77,3.58,0,5.12-4.55,2.27-6.72Z",
    fill: "#ffad00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.41,40.93l-31.42-23.99c-1.5-1.14-3.57-1.14-5.07,0l-10.13,7.71-17.35-13.12c-1.34-1.02-3.2-1.02-4.54,0-1.96,1.5-1.96,4.45,0,5.95l38.7,29.41c.65.5,1.45.77,2.27.77,3.58,0,5.12-4.55,2.27-6.72l-15.18-11.58,6.49-4.93,29.41,22.46c.65.5,1.45.77,2.27.77,3.58,0,5.12-4.55,2.27-6.72Z",
    fill: "#ffad00",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.99,57.11c5.21,0,8.66,2.48,10.53,5.52,1.18,1.9-.24,4.36-2.47,4.36h0c-1.04,0-2.01-.55-2.5-1.47-1.04-1.96-3.05-3.22-5.61-3.22-4.2,0-6.86,3.41-6.86,8.25s2.67,8.2,6.86,8.2c2.56,0,4.58-1.27,5.61-3.22.49-.92,1.46-1.47,2.5-1.47h0c2.24,0,3.65,2.46,2.47,4.36-1.88,3.04-5.33,5.52-10.53,5.52-7.55,0-12.79-5.97-12.79-13.38s5.23-13.43,12.79-13.43Z",
    fill: "#333f48",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.61,62.88c-4.15-.03-6.62,2.17-6.62,7.11v10.62c0,1.5-1.22,2.72-2.72,2.72h-.45c-1.5,0-2.72-1.22-2.72-2.72v-20.19c0-1.5,1.22-2.72,2.72-2.72h0c1.5,0,2.72,1.22,2.72,2.72v.84c.9-1.56,2.92-3.62,6.98-3.79,1.5-.06,1.42,1.21,1.42,1.21v2.85s.14,1.37-1.33,1.36Z",
    fill: "#333f48",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.22,76.17c0-4.34,3.06-7.16,9.83-8.1l7.41-1.04v-.39c0-3.11-1.98-4.69-5.48-4.69-2.45,0-4.1.84-4.91,2.29-.51.9-1.41,1.51-2.45,1.51h-.05c-2.12,0-3.5-2.32-2.39-4.13,1.61-2.62,4.71-4.51,9.95-4.51,7.51,0,11.06,3.7,11.06,9.58v11.8c0,.56.03,1.17.09,1.77.16,1.64-1.09,3.07-2.73,3.07h-2.2s-.35-1.28-.35-3.36c-1.73,2.62-4.69,3.95-8.79,3.95-6.37,0-8.99-3.36-8.99-7.75ZM113.64,72.32c-3.6.54-4.79,1.88-4.79,3.65,0,2.42,1.73,3.36,4.54,3.36,4.74,0,7.06-2.96,7.06-6.42v-1.63l-6.81,1.04Z",
    fill: "#333f48",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.22,46.3h.44c1.5,0,2.72,1.22,2.72,2.72v31.6c0,1.5-1.22,2.72-2.72,2.72h0c-1.5,0-2.72-1.22-2.72-2.72v-.94c-1.63,2.67-4.64,4.25-8.64,4.25-7.55,0-11.85-6.07-11.85-13.38s4.3-13.43,11.85-13.43c4,0,6.76,1.78,8.2,3.95v-12.05c0-1.5,1.22-2.72,2.72-2.72ZM144.55,62.29c-4.44,0-7.21,3.55-7.21,8.25s2.77,8.2,7.21,8.2,7.21-3.6,7.21-8.2-2.71-8.25-7.21-8.25Z",
    fill: "#333f48",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.54,80.61v-31.6c0-1.5,1.22-2.72,2.72-2.72h.44c1.5,0,2.72,1.22,2.72,2.72v31.6c0,1.5-1.22,2.72-2.72,2.72h-.44c-1.5,0-2.72-1.22-2.72-2.72Z",
    fill: "#333f48",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3,72.22c-.35,0-.64.32-.58.67.65,3.67,3.2,6,7.06,6,2.26,0,4.66-.79,6.31-2.47.59-.61,1.33-1.06,2.17-1.06h.03c2.15,0,3.45,2.5,2.11,4.17-2.23,2.78-6.22,4.4-10.77,4.4-7.75,0-12.79-5.78-12.79-13.43s5.14-13.38,12.74-13.38,12.59,5.78,12.59,13.28v.03c0,.99-.81,1.8-1.8,1.8h-17.08ZM182.44,67.87h12.22c.36,0,.65-.33.57-.68-.7-3.18-3.09-5.29-6.64-5.29s-5.93,2.15-6.72,5.28c-.09.36.2.7.57.7Z",
    fill: "#333f48",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,93.6h-.45c-1.5,0-2.72-1.22-2.72-2.72v-30.46c0-1.5,1.22-2.72,2.72-2.72h0c1.5,0,2.72,1.22,2.72,2.72v.94c1.68-2.62,4.69-4.25,8.64-4.25,7.6,0,11.9,6.07,11.9,13.43s-4.3,13.38-11.9,13.38c-3.95,0-6.76-1.73-8.2-3.95v10.91c0,1.5-1.22,2.72-2.72,2.72ZM219.45,78.73c4.44,0,7.21-3.6,7.21-8.2s-2.77-8.34-7.21-8.34-7.21,3.6-7.21,8.34,2.71,8.2,7.21,8.2Z",
    fill: "#333f48",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.28,70.54c0-7.21,5.14-13.43,13.28-13.43s13.33,6.22,13.33,13.43-5.13,13.38-13.33,13.38-13.28-6.17-13.28-13.38ZM249.57,78.73c4.3,0,7.46-3.26,7.46-8.2s-3.16-8.25-7.46-8.25-7.41,3.26-7.41,8.25,3.16,8.2,7.41,8.2Z",
    fill: "#333f48",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.04,57.7h.45c1.5,0,2.72,1.22,2.72,2.72v20.19c0,1.5-1.22,2.72-2.72,2.72h-.45c-1.5,0-2.72-1.22-2.72-2.72v-20.19c0-1.5,1.22-2.72,2.72-2.72Z",
    fill: "#333f48",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,61.11c1.09-2.02,3.7-4,7.9-4,6.22,0,9.53,4.15,9.53,10.12v13.38c0,1.5-1.22,2.72-2.72,2.72h-.45c-1.5,0-2.72-1.22-2.72-2.72v-13.07c0-2.94-2.35-5.47-5.29-5.4-3.59.08-5.82,2.39-5.82,6.32v12.15c0,1.5-1.22,2.72-2.72,2.72h-.45c-1.5,0-2.72-1.22-2.72-2.72v-20.19c0-1.5,1.22-2.72,2.72-2.72h0c1.5,0,2.72,1.22,2.72,2.72v.69Z",
    fill: "#333f48",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.53,83.47c-5.23,0-7.51-2.72-7.51-7.55v-13.53h-1.56c-1.3,0-2.35-1.05-2.35-2.35h0c0-1.3,1.05-2.35,2.35-2.35h1.56s0-4.32,0-4.32c0-1.3,1.05-2.35,2.35-2.35h1.19c1.3,0,2.35,1.05,2.35,2.35v4.32h2.44c1.3,0,2.35,1.05,2.35,2.35h0c0,1.3-1.05,2.35-2.35,2.35h-2.44s0,12.94,0,12.94c0,1.67,1.37,3.06,3.04,3.01.02,0,1.89-.1,1.65,2.66,0,0-.2,2.48-3.06,2.48Z",
    fill: "#333f48",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCradlepoint);
export default __webpack_public_path__ + "static/media/logo_cradlepoint.e4f2e28fcdae14e4a5ae770bd5c28d4f.svg";
export { ForwardRef as ReactComponent };